import React from 'react';
import './FulaniHistory.css';
import { FaBook, FaMapMarkedAlt, FaUsers, FaLanguage, FaHandshake, FaScroll } from 'react-icons/fa';

const FulaniHistory = () => {
  return (
    <div className="history-page">
      <div className="history-hero">
        <h1>The Rich History of the Fulani People</h1>
        <p>Discover the fascinating journey of one of Africa's most influential ethnic groups</p>
      </div>

      <div className="history-content">
        <section className="history-section origins">
          <div className="section-icon">
            <FaMapMarkedAlt />
          </div>
          <div className="section-content">
            <h2>Origins and Migration</h2>
            <p>The Fulani people, also known as Fula or Fulbe, have a rich history that spans centuries. Their origins can be traced back to the Senegambia region, from where they began their remarkable migration across West and Central Africa.</p>
            <div className="timeline">
              <div className="timeline-item">
                <h3>Early History</h3>
                <p>First settlements in the Senegambia region</p>
              </div>
              <div className="timeline-item">
                <h3>Migration Period</h3>
                <p>Spread across West and Central Africa</p>
              </div>
              <div className="timeline-item">
                <h3>Modern Era</h3>
                <p>Present-day Fulani communities</p>
              </div>
            </div>
          </div>
        </section>

        <section className="history-section culture">
          <div className="section-icon">
            <FaUsers />
          </div>
          <div className="section-content">
            <h2>Cultural Heritage</h2>
            <div className="culture-grid">
              <div className="culture-card">
                <h3>Traditional Values</h3>
                <p>Strong emphasis on family, community, and hospitality</p>
              </div>
              <div className="culture-card">
                <h3>Art and Music</h3>
                <p>Rich traditions in music, dance, and oral storytelling</p>
              </div>
              <div className="culture-card">
                <h3>Social Structure</h3>
                <p>Unique social organization and leadership systems</p>
              </div>
            </div>
          </div>
        </section>

        <section className="history-section language">
          <div className="section-icon">
            <FaLanguage />
          </div>
          <div className="section-content">
            <h2>Language and Literature</h2>
            <p>Pulaar, the language of the Fulani people, is a member of the Niger-Congo language family. It has played a crucial role in preserving the cultural heritage and traditions of the Fulani people.</p>
            <div className="language-features">
              <div className="feature">
                <h3>Written Tradition</h3>
                <p>Rich history of written literature and poetry</p>
              </div>
              <div className="feature">
                <h3>Oral Tradition</h3>
                <p>Strong tradition of oral storytelling and history</p>
              </div>
              <div className="feature">
                <h3>Modern Usage</h3>
                <p>Contemporary applications in education and media</p>
              </div>
            </div>
          </div>
        </section>

        <section className="history-section influence">
          <div className="section-icon">
            <FaHandshake />
          </div>
          <div className="section-content">
            <h2>Global Influence</h2>
            <p>The Fulani people have made significant contributions to various aspects of global culture, from literature and music to politics and social organization.</p>
            <div className="influence-grid">
              <div className="influence-card">
                <h3>Cultural Exchange</h3>
                <p>Contributions to global cultural diversity</p>
              </div>
              <div className="influence-card">
                <h3>Economic Impact</h3>
                <p>Influence on trade and commerce in West Africa</p>
              </div>
              <div className="influence-card">
                <h3>Social Development</h3>
                <p>Contributions to social and political systems</p>
              </div>
            </div>
          </div>
        </section>

        <section className="history-section preservation">
          <div className="section-icon">
            <FaScroll />
          </div>
          <div className="section-content">
            <h2>Preserving Heritage</h2>
            <p>Today, efforts are being made to preserve and promote Fulani culture and language through various initiatives, including education, digital platforms, and cultural events.</p>
            <div className="preservation-actions">
              <div className="action-item">
                <h3>Education</h3>
                <p>Language learning programs and cultural education</p>
              </div>
              <div className="action-item">
                <h3>Digital Preservation</h3>
                <p>Online resources and digital archives</p>
              </div>
              <div className="action-item">
                <h3>Cultural Events</h3>
                <p>Festivals and celebrations of Fulani heritage</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default FulaniHistory; 